// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-clamp-3[data-v-4864ab50]{-webkit-line-clamp:3}.line-clamp-3[data-v-4864ab50],.line-clamp-4[data-v-4864ab50]{-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.line-clamp-4[data-v-4864ab50]{-webkit-line-clamp:4}.archive-review-body-probe[data-v-4864ab50]{inset:0 auto auto 0;pointer-events:none;position:absolute;visibility:hidden;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
